export const GET_RESULT = 'get_result'



// WEBPACK FOOTER //
// ./src/store/module/result/mutations-types.js